import React, { useEffect, useState, useContext } from 'react'
import {
    CognitoIdentityProviderClient,
    ConfirmForgotPasswordCommand,
} from "@aws-sdk/client-cognito-identity-provider"
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"
import Spinner from "../ui-elements/Spinner"
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import Modal from '../ui-elements/Modal'
import { useNavigate, useParams } from 'react-router-dom'
import Password from './auth_formfields/Password'
import Text from './auth_formfields/Text'
import { isValidCognitoPassword } from '../utils/isValidCognitoPassword'

type Props = {
    setForgotPasswordEmail: React.Dispatch<React.SetStateAction<any>>
    forgotPasswordEmail: string
}


function ForgotPasswordCodeForm({
    setForgotPasswordEmail,
    forgotPasswordEmail
}: Props) {

    const {
        tableData,
        setShowModal,
        sendMessageToWebsocket,
        currentOrganisation,
        orgIdFromQrCode
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
    const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})




    const validate = () => {
        let isValid = true
        let newFormErrors: ObjectStringKeyAnyValue = {}

        if (
            !formFields["passwordResetCode"]
        ) {
            isValid = false
            newFormErrors["passwordResetCode"] = 'Please enter a valid code'
        }

        if (
            !formFields["newPassword"] ||
            !isValidCognitoPassword(formFields["newPassword"])
        ) {
            isValid = false
            newFormErrors["newPassword"] = 'Please enter a valid password. Passwords must be at least 8 characters long and contain at least one number, uppercase, lowercase, and symbol.'
        }

        if (
            formFields["newPassword"] !== formFields["newPasswordConfirm"]
        ) {
            isValid = false
            newFormErrors["newPasswordConfirm"] = 'Passwords must match'
        }

        setFormErrors(newFormErrors)
        return isValid
    }




    const validateAndSave = () => {
        const isValid = validate()

        if (isValid) {
            setShowModal({ "spinner": "Sending code..." })
            const client = new CognitoIdentityProviderClient({ region: CloudformationOutputs['AWSRegion'] })
            const username = forgotPasswordEmail.toLowerCase()
            const confirmationCode = formFields["passwordResetCode"]
            const newPassword = formFields["newPassword"]
            const command = new ConfirmForgotPasswordCommand({
                ClientId: CloudformationOutputs['UserPoolClientId'],
                Username: username,
                ConfirmationCode: confirmationCode,
                Password: newPassword,
            })
            client.send(command)
                .then((response: any) => {
                    setForgotPasswordEmail('')
                    setShowModal({ 'success': 'Password successfully reset! You can now log in with your new password.' })
                    navigate('/login')
                })
                .catch((error: any) => {
                    setShowModal({ "error": "Could not reset password" })
                    console.error("Error resetting password", error)
                })
        }
    }




    return <div className={`w-full flex flex-col gap-4`}>

        <h3 className={`font-righteous text-2xl text-brand-dark`}>Forgot your password?</h3>
        <p>We have sent a password reset code to: <span className={`font-bold`}>{forgotPasswordEmail}</span></p>
        <p>Please check your email and enter the code below:</p>



        <Text
            labelText={'Code'}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'passwordResetCode'}
            size={'big'}
            center={true}
            required={true}
        />

        <Password
            labelText={'New password'}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'newPassword'}
            size={'big'}
            center={true}
            required={true}
        />

        <Password
            labelText={'Confirm new password'}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'newPasswordConfirm'}
            size={'big'}
            center={true}
            required={true}
        />



        <div className={`w-full flex flex-row gap-4`}>
            <Button
                onClick={() => {
                    setForgotPasswordEmail('')
                    navigate('/login')
                }}
                text={'Cancel'}
                variant={'gray'}
                size={'big'}
                sameWindow={true}
            />
            <Button
                onClick={validateAndSave}
                text={'Continue'}
                variant={'secondary'}
                size={'big'}
                sameWindow={true}
            />
        </div>
    </div>
}
export default ForgotPasswordCodeForm